import AssetsLiabilities from "../../Components/Pages/MMPClient/AssetsLiabilities/AssetsLiabilities";
import ChangePassword from "../../Components/Pages/MMPClient/Auth/ChangePassword";
import MMPLogin from "../../Components/Pages/MMPClient/Auth/MMPLogin";
import MMPSignup from "../../Components/Pages/MMPClient/Auth/MMPSignup";
import Profile from "../../Components/Pages/MMPClient/Auth/Profile";
import Dashboard from "../../Components/Pages/MMPClient/Dashboard/Dashboard";
import { Feedback } from "../../Components/Pages/MMPClient/Feedback/Feedback";
import HomeLoanResults from "../../Components/Pages/MMPClient/HomeLoanResults/HomeLoanResults";
import HomeLoanSimulator from "../../Components/Pages/MMPClient/HomeLoanSimulator/HomeLoanSimulator";
import IncomeExpenses from "../../Components/Pages/MMPClient/IncomeExpenses/IncomeExpenses";
import InvestmentProperty from "../../Components/Pages/MMPClient/InvestmentProperty";
import { EditInvestmentProperty } from "../../Components/Pages/MMPClient/InvestmentProperty/EditInvestmentProperty";
import PropertySearch from "../../Components/Pages/MMPClient/PropertySearch/PropertySearch";

export const MMPClientRoutes = [
  { path: `${process.env.PUBLIC_URL}/MMPDashboard`, element: <Dashboard /> },
  { path: `${process.env.PUBLIC_URL}/MMPAssetsLiabilities`, element: <AssetsLiabilities /> },
  { path: `${process.env.PUBLIC_URL}/MMPIncomeExpenses`, element: <IncomeExpenses /> },
  { path: `${process.env.PUBLIC_URL}/MMPHomeloanSimulator`, element: <HomeLoanSimulator /> },
  { path: `${process.env.PUBLIC_URL}/MMPHomeloanResults`, element: <HomeLoanResults /> },
  { path: `${process.env.PUBLIC_URL}/MMPProperty`, element: <PropertySearch /> },
  { path: `${process.env.PUBLIC_URL}/InvestmentProperty`, element: <InvestmentProperty /> },
  { path: `${process.env.PUBLIC_URL}/EditInvestmentProperty/:propertyId`, element: <EditInvestmentProperty /> },
  { path: `${process.env.PUBLIC_URL}/Profile`, element: <Profile /> },
  { path: `${process.env.PUBLIC_URL}/ChangePassword`, element: <ChangePassword /> },
  { path: `${process.env.PUBLIC_URL}/Feedback`, element: <Feedback /> },
];

export const MMPClientAuthRoutes = [
  { path: `${process.env.PUBLIC_URL}/MMPLogin`, element: <MMPLogin /> },
  { path: `${process.env.PUBLIC_URL}/MMPSignup`, element: <MMPSignup /> },
];
